import React, { useState, useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import countrie from '../countrie/countrie';

const FormulaireInscritMesure = () => {
  const location = useLocation();
  const { formation, mode = 'Non sélectionné' } = location.state || {};

  const [formData, setFormData] = useState({
    civility: 'M.',
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    postOccupe: '',
    employeur: '',
    pays: '',
    lieu: '',
    nombrePersonnes: '',
    message: '',
    dateDebut: '',
    dateFin: '',
    Modeformation: '',
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);

  const recaptchaRef = useRef();

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const Url = process.env.REACT_APP_URL_DEV;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    const requiredFields = [
      'prenom',
      'nom',
      'email',
      'telephone',
      'postOccupe',
      'employeur',
      'pays',
      'lieu',
      'nombrePersonnes',
      'dateDebut',
      'dateFin',
      'Modeformation',
      'message',
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = 'Ce champ est obligatoire.';
      }
    });

    if (!captchaToken) {
      newErrors.captcha = 'Veuillez valider le reCAPTCHA.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const dataToSend = {
      ...formData,
      mode,
      formationNom: formation?.formationNom || 'N/A',
      formationCode: formation?.formationCode || 'N/A',
      formationDuree: formation?.formationDuree || 'N/A',
      formationLangue: formation?.formationLangue || 'N/A',
      captchaToken,
    };

    try {
      const response = await axios.post(
        `${Url}/api/form/inscrireSurMesure`,
        dataToSend,
      );
      setSuccess('Inscription réussie !');
      setFormData({
        civility: 'M.',
        prenom: '',
        nom: '',
        email: '',
        telephone: '',
        postOccupe: '',
        employeur: '',
        pays: '',
        lieu: '',
        nombrePersonnes: '',
        message: '',
        dateDebut: '',
        dateFin: '',
        Modeformation: '',
      });
      setCaptchaToken(null);
      recaptchaRef.current.reset();
    } catch (err) {
      setErrors({ global: "Une erreur est survenue lors de l'inscription." });
      setSuccess('');
    }
  };

  return (
    <div className="container22">
      <div className="header22">
        <h2>Formulaire d&apos;inscription Sur Mesure</h2>
        <p className="description">{formation?.formationNom || 'N/A'}</p>
        <p>
          <strong>Code :</strong> {formation?.formationCode || 'N/A'}
        </p>
        <p>
          <strong>Durée :</strong> {formation?.formationDuree || 'N/A'}
        </p>
        <p>
          <strong>Langue :</strong> {formation?.formationLangue || 'N/A'}
        </p>
      </div>

      {errors.global && <p className="error-message">{errors.global}</p>}
      {success && <p className="success-message">{success}</p>}

      <form className="form" onSubmit={handleSubmit}>
        <select
          name="civility"
          className="form-control"
          value={formData.civility}
          onChange={handleInputChange}
        >
          <option value="M.">M.</option>
          <option value="Mme">Mme</option>
        </select>

        <input
          type="text"
          name="prenom"
          placeholder="Prénom *"
          className="form-control"
          value={formData.prenom}
          onChange={handleInputChange}
        />
        {errors.prenom && <p className="error-message">{errors.prenom}</p>}

        <input
          type="text"
          name="nom"
          placeholder="Nom *"
          className="form-control"
          value={formData.nom}
          onChange={handleInputChange}
        />
        {errors.nom && <p className="error-message">{errors.nom}</p>}

        <input
          type="email"
          name="email"
          placeholder="Email *"
          className="form-control"
          value={formData.email}
          onChange={handleInputChange}
        />
        {errors.email && <p className="error-message">{errors.email}</p>}

        <PhoneInput
          country="tn"
          placeholder="N° téléphone *"
          value={formData.telephone}
          inputStyle={{ width: '100%' }}
          onChange={(value) => setFormData({ ...formData, telephone: value })}
        />
        {errors.telephone && (
          <p className="error-message">{errors.telephone}</p>
        )}

        <input
          type="text"
          name="postOccupe"
          placeholder="Poste occupé *"
          className="form-control"
          value={formData.postOccupe}
          onChange={handleInputChange}
        />
        {errors.postOccupe && (
          <p className="error-message">{errors.postOccupe}</p>
        )}

        <input
          type="text"
          name="employeur"
          placeholder="Employeur *"
          className="form-control"
          value={formData.employeur}
          onChange={handleInputChange}
        />
        {errors.employeur && (
          <p className="error-message">{errors.employeur}</p>
        )}

        <select
          name="pays"
          className="form-control"
          value={formData.pays}
          onChange={handleInputChange}
        >
          <option value="">Sélectionnez votre pays</option>
          {countrie.map((c, i) => (
            <option key={i} value={c}>
              {c}
            </option>
          ))}
        </select>
        {errors.pays && <p className="error-message">{errors.pays}</p>}

        {/* ✅ Lieu modifié en select box */}
        <select
          name="lieu"
          className="form-control"
          value={formData.lieu}
          onChange={handleInputChange}
        >
          <option value="">Sélectionnez un lieu *</option>
          <option value="Tunis - Tunisie">Tunis - Tunisie</option>
          <option value="Casablanca - Maroc">Casablanca - Maroc</option>
          <option value="Dubai - UAE">Dubai - UAE</option>
        </select>
        {errors.lieu && <p className="error-message">{errors.lieu}</p>}

        <input
          type="text"
          name="nombrePersonnes"
          placeholder="Nombre de personnes *"
          className="form-control"
          value={formData.nombrePersonnes}
          onChange={handleInputChange}
        />
        {errors.nombrePersonnes && (
          <p className="error-message">{errors.nombrePersonnes}</p>
        )}

        <div className="form-row">
          <input
            type="date"
            name="dateDebut"
            className="form-control half-width"
            value={formData.dateDebut}
            onChange={handleInputChange}
          />

          <input
            type="date"
            name="dateFin"
            className="form-control half-width"
            value={formData.dateFin}
            onChange={handleInputChange}
          />
        </div>
        {errors.dateDebut && (
          <p className="error-message">{errors.dateDebut}</p>
        )}

        <select
          name="Modeformation"
          className="form-control"
          value={formData.Modeformation}
          onChange={handleInputChange}
        >
          <option value="">Mode de formation</option>
          <option value="Présentiel">Présentiel</option>
          <option value="En ligne">En ligne</option>
        </select>
        {errors.Modeformation && (
          <p className="error-message">{errors.Modeformation}</p>
        )}

        <textarea
          name="message"
          placeholder="Message *"
          className="form-control"
          rows="4"
          value={formData.message}
          onChange={handleInputChange}
        ></textarea>
        {errors.message && <p className="error-message">{errors.message}</p>}

        <div style={{ margin: '20px 0', textAlign: 'center' }}>
          <ReCAPTCHA
            sitekey="6Lf8vqIrAAAAAJSU8cRjXvxEO3864ewH_Np9j9I_"
            ref={recaptchaRef}
            onChange={handleCaptchaChange}
          />
          {errors.captcha && <p className="error-message">{errors.captcha}</p>}
        </div>

        <button type="submit" className="btn-submit">
          DEMANDER UN DEVIS
        </button>
      </form>
    </div>
  );
};

export default FormulaireInscritMesure;
